import type { ColorPalette } from 'config/theme/types';

export const zdfLogoColors: Partial<ColorPalette> = {
    // Text
    colorTextPrimary: '#34393F',
    colorTextSecondaryOnBanner: '#34393F',
    colorTextSecondary: '#535E66',
    colorTextDisabled: '#96999C',
    colorTextHint: '#717579',
    colorTextAccent: '#BF4900',
    colorTextWarning: '#B50011',
    colorTextSuccess: '#00AF87',
    colorTextOnPrimaryButton: '#FFFFFF',
    colorTextOnAccentColorBg: '#FFFFFF',
    colorTextOnEntryPointColorBg: '#FFFFFF',
    colorTextOnTagLight: '#34393F',
    colorTextOnToastDark: '#FFFFFF',
    colorTextOnDataVizCategory: '#FFFFFF',
    colorTextOnTeaserButton: '#FFFFFF',

    // Button
    colorButtonPrimary: '#323746',
    colorButtonAccent: '#FA7D19',
    colorButtonSecondary: '#FFFFFF',
    colorButtonDisabled: '#DEDFE0',
    colorButtonSliderThumb: '#FFFFFF',
    colorButtonTeaser: '#323746',

    // Surface
    colorSurfacePrimary: '#FFFFFF',
    colorSurfaceSecondary: '#F5F5F5',
    colorSurfaceHighlight: '#DAEBF1',
    colorSurfaceHighlightShade1: '#CDE4EC',
    colorSurfaceHighlightShade2: '#C0DDE6',
    colorSurfaceBannerWarning: '#F9EBEC',
    colorSurfaceBannerSuggestion: '#DAEBF1',
    colorSurfaceBannerSuccess: '#BEE2AD',
    colorSurfaceBannerInfo: '#E6F2F6',
    colorSurfaceUserBlock: '#B50011',
    colorSurfaceUserWarning: '#EEC040',
    colorSurfaceUserUnblock: '#92CD74',
    colorSurfaceUserVerified: '#DAEBF1',
    colorSurfaceSliderPulse: '#0099CC33',
    colorSurfaceToggleBackground: '#D9D9D9',
    // Tag
    colorTagDefault: '#E8E8E8',
    colorTagAccent: '#FA7D19',
    colorTagAccentLight: '#FFD8B9',
    colorTagHighlight: '#F9EBEC',
    colorTagWarning: '#F9EBEC',
    colorTagSuccess: '#BEE2AD',
    colorTagVerified: '#DAEBF1',
    colorTagWhite: '#FFFFFF',

    // Border
    colorBorderPrimary: '#E5E5E5',
    colorBorderPrimaryOnBanner: '#32374626',
    colorBorderSelected: '#323746',
    colorBorderAccent: '#FA7D19',
    colorBorderAccentLight: '#FFD8B9',
    colorBorderWarning: '#B50011',
    colorBorderFace: '#FFFFFF',
    colorBorderSliderThumb: '#96999C',
    colorBorderDataVizBar: '#FFFFFF',

    // DataViz
    colorDataVizScale1: '#FA7D19',
    colorDataVizScale2: '#FCB175',
    colorDataVizScale3: '#FFD8B9',
    colorDataVizOther: '#E5E5E5',
    colorDataVizCategory1: '#FA7D19',
    colorDataVizCategory2: '#05789E',
    colorDataVizCategory3: '#763A35',
    colorDataVizCategory4: '#A57328',
    colorDataVizCategory5: '#0099CC',

    // Entry point colors
    colorEntryPointColorGreen: '#05789E',
    colorEntryPointColorGreenTint: '#0099CC',
};
